import * as React from 'react';
/**
 *
 * Original name: space
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A330
 *
 */
export const SpacePictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M32 8h-2v22.805L9.376 41.911l.7 1.673C13.471 51.707 21.053 56 32 56c15.477 0 24-8.523 24-24S47.477 8 32 8Zm0 44c-8.537 0-14.4-2.8-17.45-8.333L34 33.194v-21.14c11.946.658 18 7.36 18 19.946 0 13.271-6.729 20-20 20ZM12 32c0-11.088 4.715-17.591 14-19.436V8.5C14.344 10.5 8 18.662 8 32c-.005 1.961.153 3.92.472 5.855l3.756-2.022A33.378 33.378 0 0 1 12 32Z", fill: "currentColor" })));
